// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ck-z","summaryPar":"dk-z","ratingCategories":"ek-z","reviewerInfo":"fk-z","reviewTypes":"gk-z","expanded":"hk-z"};